import Vue from 'vue'
import store from '@/framework/store'
import { isString, isArray } from '@/framework/utils/validate'
import appConfig from '@/config/app-config'

// you can set in settings.js
// errorLog:'production' | ['production', 'development']
const { errorLog: needErrorLog } = appConfig

function checkNeed() {
  const env = process.env.NODE_ENV
  if (isString(needErrorLog)) {
    return env === needErrorLog
  }
  if (isArray(needErrorLog)) {
    return needErrorLog.includes(env)
  }
  return false
}

if (checkNeed()) {
  Vue.config.errorHandler = function(err, vm, info, a) {
  // Don't ask me why I use Vue.nextTick, it just a hack.
  // detail see https://forum.vuejs.org/t/dispatch-in-vue-config-errorhandler-has-some-problem/23500
    // Vue.nextTick(() => {
    //   store.dispatch('errorLog/addErrorLog', {
    //     err,
    //     vm,
    //     info,
    //     url: window.location.href
    //   })
    //   console.error(err, info)
    // })
  }
}
